<template>
  <v-container  fluid style="margin: 20px; padding: 10px; width: 100%">
    <v-card class="pl-10 pr-10">
      <v-card-title class="pb-0">
        <b>Controller Board</b>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
         <v-row>
          <v-col md="11">
            <DatePicker
              :disabled="true"
              label="วันที่"
              @dateFormatted="setDate"
            ></DatePicker>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <UserBranchDropdown
              :pageCode="pageCode"
              @onUserBranchChange="setCurrentBranch"
              @onUserBranchNameChange='setCurrentBranchName'
            ></UserBranchDropdown>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-row>
          <v-col md="11">
             <v-btn  class="ma-2" color="primary" small target="_blank" @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-subtitle class="px-0">
        <ControllerBoard
          :countStatusCar="countStatusCar"
          :countStatusCarWait="countStatusCarWait"
          :sum="sum"
          :branchCode="branchCode"
          ref="table"
        ></ControllerBoard>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
import UserBranchDropdown from '@/components/Shared/UserBranchDropdown';
import ControllerBoard from './ListControllerBoard';
import DatePicker from '@/components/Shared/DatePicker';
import { listBoard, listBoardWait, getBoardheader,printControllerBoard } from '@/api/job/job-api.js';

export default {
  name: 'Page',
  components: {
    UserBranchDropdown,
    ControllerBoard,
    DatePicker,
  },
  props: ['pageCode'],
  data: () => ({
    branchCode: null,
    date: '',
    tableData: [],
    countStatusCar: 0,
    countStatusCarWait: 0,
    sum: 0,
  }),
  methods: {
    setDate(val) {
      if (val) {
        this.tableData = Object.assign([], []);
        this.$loading(true);
        listBoard(this.branchCode)
          .then((response) => {
            this.$refs.table.setTableOnProcess(response);
            this.$loading(false);
          })
          .catch(() => {
            this.$loading(false);
          });

        listBoardWait(this.branchCode)
          .then((response) => {
            this.$refs.table.setTableWait(response);
            this.$loading(false);
          })
          .catch(() => {
            this.$loading(false);
          });

        getBoardheader(this.branchCode).then((rs) => {
          this.$refs.table.setHeader(rs);
        });
      }
    },
    setCurrentBranch(branchCode) {
      if (branchCode) {
        this.branchCode = branchCode;
      }
    },
    setCurrentBranchName(branchName) {
      this.branchName = branchName;
    },
    createReport(){
      this.$loading(true);
      printControllerBoard(this.branchCode,this.branchName);
      this.$loading(false);

    }
  },
};
</script>
